import { useEffect, useState } from 'react';

import { fetchCustomers } from '../api/customers.api';
import type { CustomerDTO } from '../api/customers.api';
import type { Customer } from '../customer.types';


function mapCustomer(dto: CustomerDTO): Customer {
  return {
    id: String(dto.id),
    name: dto.full_name || '-',
    contact: dto.username
      ? `@${dto.username}`
      : String(dto.telegram_id),

    status: 'active',

    activeServicesCount: dto.orders_count ?? 0,

    telegramId: dto.telegram_id,

    joinedAt: dto.joined_at,

    ordersCount: dto.orders_count ?? 0,

    totalPurchases: dto.total_purchases ?? 0,

    generatedCommission: dto.generated_commission ?? 0,
  };
}


export function useCustomers() {

  const [customers, setCustomers] = useState<Customer[]>([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {

    async function load() {
      try {
        const response = await fetchCustomers();

        setCustomers(
          response.customers.map(mapCustomer)
        );

      } finally {
        setLoading(false);
      }
    }

    load();

  }, []);


  return {
    customers,
    loading,
  };
}
